import Contact from "../../components/Contact/Contact";
import Layout from "../../layout/Layout";
export default function ContactUs() {
  return (
      <Contact />
  );
}
